import { getStressAssessmentRole } from '@fukuri-admins/utils/common/cookies';
import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from '~/utils/routes';

export const StressAssessmentRoleRoute: React.FC = () => {
  const stressAssessmentRole = getStressAssessmentRole();
  if (!stressAssessmentRole) {
    return <Navigate to={ROUTES.STRESS_ASSESSMENTS.ROLE_SELECT} />;
  }

  return <Outlet />;
};
